module.exports = __webpack_public_path__ + "static/media/DOT.df0b85d2.png";